import { configureClient } from "@kkp/api-client";
import { getApiBaseUrl } from "../lib/env";

configureClient({
  getBaseUrl: getApiBaseUrl,
  sessionExpiredKey: "kkp_admin_session_expired",
  sessionStorageKey: "kkp_admin_session_v1",
});

export { apiRequest, apiRequestEnvelope, ApiError } from "@kkp/api-client";
export type {
  ApiEnvelope,
  ApiMeta,
  ErrorDetail,
  ApiRequestOptions,
  HttpMethod,
} from "@kkp/api-client";
